import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../components/FormikControl/FormikControl';
import essLeaveRequestServices from '../essLeaveRequestServices';
import { useAlert } from '../../../../context/AlertContext';
import { useEssAppData } from '../../../../context/AppESSDataContext';
import moment from 'moment';


function EssLeaveRequestForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useEssAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        startDate:moment().add(1, 'days').format(moment.HTML5_FMT.DATE),
        endDate:moment().add(1, 'days').format(moment.HTML5_FMT.DATE),
        leaveType:"",
        message:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            startDate:data.startDate,
            endDate:data.endDate,
            leaveType:data.leaveType,
            message:data.message,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        startDate:Yup.string().required("Required"),
        endDate:Yup.string().required("Required"),
        leaveType:Yup.string().required("Required"),
        message:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        essLeaveRequestServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> New Leave Request</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Leave Request Form"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Start Date" name="startDate" 
                                                        
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="End Date" name="endDate" 
                                                        
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Leave Type" name="leaveType"  
                                                        options={masters['leave-type']} multiple={false} 
                                                    />
                                                </div>
                                                
                                                
                                                <hr className='my-3' />
                                                

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true} rows={5}
                                                        label="Message" name="message"   
                                                    />
                                                </div>

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default EssLeaveRequestForm